import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@spotnana/blocks/src/Button';
import ExpansionPanel from '@spotnana/pixel-react/dist/ExpansionPanel';
import { IFlightAmenity, ILegUTA } from 'obt-common';

import { ModalProvider } from '../../../../v1-components/ModalProvider';
import RulesAndRestrictions from '../../checkout/shared/components/RulesAndRestrictions';

import { container } from './styles';

export type FareRulesRequestIdInfo = { pnrId: string } | { searchId: string; lastLegRateOptionId: string };

interface IProps {
  utas: ILegUTA[];
  showRawFareRules: boolean;
  amenities: IFlightAmenity[];
  fareRulesRequestId: FareRulesRequestIdInfo;
  onFareRulesAndAmenitiesClick?: VoidFunction;
}

const AmenitiesAndFareRules = ({
  utas,
  showRawFareRules,
  amenities,
  fareRulesRequestId,
  onFareRulesAndAmenitiesClick,
}: IProps): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { t: tt } = useTranslation('WEB');

  const handleShowFareRulesAndRestrictions = (): void => {
    onFareRulesAndAmenitiesClick?.();
    setIsExpanded(!isExpanded);
  };

  const hasFareRulesOrAmenities = utas.length + amenities.length > 0;

  if (!hasFareRulesOrAmenities) {
    return <></>;
  }

  return (
    <ModalProvider>
      <div css={container} data-testid="amenities-and-fare-rules">
        <Button
          variant="ghost"
          onClick={handleShowFareRulesAndRestrictions}
          endIcon={isExpanded ? 'ChevronUp' : 'ChevronDown'}
        >
          {tt('Fare rules, restrictions and amenities')}
        </Button>
        {isExpanded && (
          <ExpansionPanel expand={isExpanded} data-testid="flight-checkout-rules-and-restrictions-container">
            <RulesAndRestrictions
              fareRulesRequestId={fareRulesRequestId}
              utas={utas}
              showRawFareRules={showRawFareRules}
              amenities={amenities}
              source="checkout"
            />
          </ExpansionPanel>
        )}
      </div>
    </ModalProvider>
  );
};

export default AmenitiesAndFareRules;
